import script from "./ResidentStatCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ResidentStatCard.vue?vue&type=script&setup=true&lang=js"

import "./ResidentStatCard.vue?vue&type=style&index=0&id=c47c6550&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c47c6550"]])

export default __exports__